import React from "react";
import Footer from "../components/Footer";
import ContactUs from "../components/ContactUs";

function Contact() {
    
    return (
        <React.Fragment>
            <ContactUs/>
            <Footer />
        </React.Fragment>
    )
}

export default Contact